/**
 * Invoice Upload Tab Component
 * Wrapper for InvoiceUpload component for use within DataEntryPage
 */

import React from 'react';
import styled from 'styled-components';
import { InvoiceUpload } from '../invoice/InvoiceUpload';

// ============================================================================
// Styled Components
// ============================================================================

const TabContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

// ============================================================================
// Component
// ============================================================================

export const InvoiceUploadTab: React.FC = () => {
  return (
    <TabContainer>
      <InvoiceUpload />
    </TabContainer>
  );
};
